import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=7b0a5ee4&scoped=true&class=ml-3"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=7b0a5ee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0a5ee4",
  null
  
)

export default component.exports